/**
 * Translations do not need state. Sticking them here, so we can require them anywhere
 * we want vs passing translation props down all of the time.
 * @todo Need to deprecate dependencies on translations from store throughout app if
 * this POJO proves to be the better approach.
 */
const translations = (typeof window !== 'undefined' ? window.__TRANSLATIONS__ : {});
export default translations;


// WEBPACK FOOTER //
// ./src/universal/utils/translations.js